const trails_es = require('./trails.json')
export default trails_es